import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { resolveTenantUrl, tenantOverrideOptions } from 'src/app/Common/ApiConfigurationService/resolve-tenant-url.util';
import {
  compEmailTempVarCreateRequestDTO,
  compEmailTempVarUpdateRequestDTO,
  compEmailTempVarDeleteRequestDTO,
  compEmailTempVarReadByIdRequestDTO,
  compEmailTempVarReadByTemplateIdRequestDTO,
  compEmailVarResponseItem,
  compEmailVarResponseList
} from './company-email-templates-variables.interface';

import {
  CompanyEmailTemplateVariable_Create,
  CompanyEmailTemplateVariable_Update,
  CompanyEmailTemplateVariable_Delete,
  CompanyEmailTemplateVariable_ReadAll,
  CompanyEmailTemplateVariable_ReadById,
  CompanyEmailTemplateVariable_ReadByTemplateID
} from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class EmailVariableService {

  constructor() { }

  http = inject(HttpClient);

  CompanyEmailTemplateVariable_Create(data: compEmailTempVarCreateRequestDTO): Observable<compEmailVarResponseItem> {
    return this.http.post<compEmailVarResponseItem>(CompanyEmailTemplateVariable_Create, data);
  }

  CompanyEmailTemplateVariable_Update(data: compEmailTempVarUpdateRequestDTO): Observable<compEmailVarResponseItem> {
    return this.http.post<compEmailVarResponseItem>(CompanyEmailTemplateVariable_Update, data);
  }

  CompanyEmailTemplateVariable_Delete(data: compEmailTempVarDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(CompanyEmailTemplateVariable_Delete, data);
  }

  CompanyEmailTemplateVariable_ReadAll(): Observable<compEmailVarResponseList> {
    return this.http.get<compEmailVarResponseList>(CompanyEmailTemplateVariable_ReadAll);
  }

  CompanyEmailTemplateVariable_ReadById(data: compEmailTempVarReadByIdRequestDTO): Observable<compEmailVarResponseList> {
    return this.http.post<compEmailVarResponseList>(CompanyEmailTemplateVariable_ReadById, data);
  }

  // baseUrlOverride (optional): the viewed tenant's own AM gateway origin,
  // e.g. CompanyDetailComponent.apiConfigOverride.AM. Omitted for every
  // other caller - behaves exactly as before.
  CompanyEmailTemplateVariable_ReadByTemplateId(data: compEmailTempVarReadByTemplateIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<compEmailVarResponseList> {
    return this.http.post<compEmailVarResponseList>(resolveTenantUrl(CompanyEmailTemplateVariable_ReadByTemplateID, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
  }

}